module.exports = __webpack_public_path__ + "img/boa-rosada.220f1ba0.jpeg";